// extracted by mini-css-extract-plugin
export default {"search-form":"Y_Qt flex-grow-1 form-group mb-0"};